
import { mapState } from "vuex";

import { PAGE_TYPE, QUERY_STORE_PAGE } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app, params: { handle }, error }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: QUERY_STORE_PAGE,
      variables: { uid: handle },
    });

    if (data == null || !data.store_api) {
      return error({ statusCode: 404, message: "Store not found ....." });
    }

    return {
      title: { text: "Stores" },
      handle,
      slices: data.store_page_content?.body ?? [],
      storeName: data.store_name,
      pageType: PAGE_TYPE,
      showOpeningHours: data.show_opening_hours ?? false,
      openingHourText: data.opening_hours_text,
      storeReviewId: data.store_review_id,
      storeApi: data.store_api,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      campaignSaleUID: data.campaign_sale_link?._meta?.uid,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
    };
  },

  computed: {
    ...mapState("app", ["isStoreReviewLoaded"]),
    ...mapState("app", ["isGoogleMapLoaded"]),
    pageTitle() {
      return this.storeName ?? [{ text: "Store" }];
    },
  },
};
